import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UiHelperService } from './ui-helper.service';

@Injectable({
  providedIn: 'root',
})
export class DataContextService {
  constructor(private http: HttpClient, private uiHelper: UiHelperService) {}

  GetData(
    url: string,
    params: any = null,
    headersObject: any = null
  ): Observable<any> {
    let httpParams = new HttpParams();

    // Flatten the params object
    if (params) {
      Object.keys(params).forEach((key) => {
        if (typeof params[key] === 'object' && params[key] !== null) {
          Object.keys(params[key]).forEach((subKey) => {
            httpParams = httpParams.append(
              `${key}[${subKey}]`,
              params[key][subKey]
            );
          });
        } else {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }

    const configuration = {
      headers: headersObject,
      params: httpParams,
    };
    return this.http.get(environment.apiUrl + url, { ...configuration });
  }

  PostData(url: string, data: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    });
    //  let options = new RequestOptions({ headers: headers });

    return this.http.post(environment.apiUrl + url, data);
  }

  PatchData(url: string, data: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    });
    //  let options = new RequestOptions({ headers: headers });

    return this.http.patch(environment.apiUrl + url, data);
  }
  PutData(url: string, data: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    });
    //  let options = new RequestOptions({ headers: headers });

    return this.http.put(environment.apiUrl + url, data);
  }

  PostDataText(url: string, data: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    });
    //   let options = new RequestOptions({ headers: headers });
    return this.http.post(environment.apiUrl + url, data, {
      responseType: 'text',
    });
  }

  PostFormData(url: string, data: any) {
    let headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    });
    return this.http.post(environment.apiUrl + url, data);
  }
  DeleteData(url: string, params: any = null, headersObject: any = null) {
    const confirguration = {
      headers: headersObject,
      params: params,
    };
    return this.http.delete(environment.apiUrl + url, { ...confirguration });
  }
  DownloadFile(url: string, params?: any) {
    return this.http
      .get(url, {
        responseType: 'blob',
        params, // Optional parameters if needed
      })
      .subscribe(
        (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;

          // Extract filename with fallback
          const filename = this.getFileNameFromUrl(url) || 'unknown.ext';
          a.download = filename;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          console.error('Download failed', error);
        }
      );
  }
  private getFileNameFromUrl(url: string): string {
    const parts = url.split('/');
    return parts[parts.length - 1]; // Extracts the filename from the URL
  }

  fetchImageBlob(url: string, token: string) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get(url, { headers, responseType: 'blob' });
  }

  downloadExcel(url: string, spinner: any, params:any = null): void {
    let httpParams = new HttpParams();

    // Flatten the params object
    if (params) {
      Object.keys(params).forEach((key) => {
        if (typeof params[key] === 'object' && params[key] !== null) {
          Object.keys(params[key]).forEach((subKey) => {
            httpParams = httpParams.append(
              `${key}[${subKey}]`,
              params[key][subKey]
            );
          });
        } else {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }
    this.http
      .get(environment.apiUrl + url, {
        observe: 'response',
        responseType: 'blob',
        params: httpParams,
      })
      .subscribe(
        (res: HttpResponse<Blob>) => {
          const blob = res.body!;
          const contentDisposition = res.headers.get('content-disposition');
          let filename = `${this.generateRandomString()}-report.xlsx`;
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match) filename = match[1];
          }

          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
          spinner.hide();
        },
        (error) => {
          const lang = localStorage.getItem('lang') || 'en';
          this.uiHelper.toastrError(
            lang === 'en' ? 'Download failed' : 'فشل في تحميل الملف',
            error.error.message
          );
          spinner.hide();
        }
      );
  }

  generateRandomString(length: number = 10): string {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }
}